<template>
  <v-app light id="toppage" ref="toppage">
    <v-toolbar :class="toolBarStyle.bgcolor + ' ' + toolBarStyle.elevate + ' ' + toolBarStyle.navHeight" :style="toolBarStyle.top" app fixed :clipped-left="clipped">
      <v-toolbar-items class="h-90x w-100" :style="toolBarStyle.counterTop">
        <div class="hidden-md-and-down mlr-auto">
          <a href="https://drdanielwai.com.sg/">
          <img class="logo pr-50" :src="logo.img" :style="toolBarStyle.counterTop" :alt="logo.alt">
          </a>
          <v-btn v-for="link in menutext" :key="link.txt" flat :class="link.cls" @click="gotopage(link.scrollto,link.goto,link.txt)">
            <span v-if="link.txt == selectedmenu" style="text-transform: capitalize;" class="color-primary font-style-main font-11">{{ link.txt }}</span>
            <span v-else style="text-transform: capitalize;" class="color-white font-style-main font-11">{{ link.txt }}</span>
          </v-btn>
        </div>
        <div class="hidden-lg-and-up w-100 text-left">
          <v-btn icon :style="toolBarStyle.counterTop" @click.stop="rightDrawer = !rightDrawer">
            <v-icon>menu</v-icon>
          </v-btn>
        </div>
        <div class="float-right text-right w-xs-100 w-sm-100 w-md-100 w-lg-100">
          <v-speed-dial v-model="fabmob" fixed bottom right direction="bottom" transition="slide-y-reverse-transition" class="hidden-lg-and-up dplay-fixed w-250x mt-20">
            <template v-slot:activator>
              <v-btn v-model="fabmob" color="blue darken-2" dark fab style="z-index:5;">
                <v-icon v-if="fabmob">mdi-phone-hangup</v-icon>
                <v-icon v-else>mdi-phone</v-icon>
              </v-btn>
            </template>
            <v-card fabmob dark left color="indigo" class="w-100 p-10 mt-50 text-left">
              <v-icon>mdi-email</v-icon>
              <span class="float-right"><a href="#contact" class="color-white" style="text-decoration: underline;">info@drdanielwai.com.sg</a></span>
            </v-card>
            <v-card fabmob dark color="indigo" class="w-100 p-10 text-left">
              <v-icon>mdi-phone</v-icon>
              <span class="float-right"><a href="tel:+6567335201" class="color-white" style="text-decoration: underline;">+65 6733 5201</a></span>
            </v-card>
          </v-speed-dial>
          <v-btn v-for="icon in menuicons" :key="icon" class="mt-0 mb-0 p-0" light icon @click="gotopage(icon,'','')">
            <v-icon class="font-20">{{ icon }}</v-icon>
          </v-btn>
          <div class="mr-xs-10 m-0 p-0">
            <v-btn style="text-transform: capitalize;" rounded v-if="language != 'id'" color="bg-primary" class="color-white" @click="setlanguage('en')">English</v-btn>
            <v-btn style="text-transform: capitalize;" depressed v-else color="bg-2-white" @click="setlanguage('en')">English</v-btn>
            <v-btn style="text-transform: capitalize;" rounded v-if="language == 'id'" color="bg-primary" class="color-white" @click="setlanguage('id')">Bahasa</v-btn>
            <v-btn style="text-transform: capitalize;" depressed v-else color="bg-2-white" @click="setlanguage('id')">Bahasa</v-btn>
          </div>
        </div>
        <v-speed-dial v-model="fab" fixed bottom right direction="bottom" transition="slide-y-reverse-transition" class="hidden-md-and-down dplay-fixed">
          <template v-slot:activator>
            <v-card outlined class="mt-20 p-20 p-xs-5" style="border-radius: 10px;">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-center">
                    <h5>MAKE AN APPOINTMENT</h5>
                  </v-list-item-title>
                  <v-divider></v-divider>
                  <v-list-item-subtitle class="ml-30">
                    <span class="font-style-main">Contact us today</span>
                    <v-btn v-model="fab" color="blue darken-2" dark fab style="z-index:5;">
                      <v-icon v-if="fab">mdi-phone-hangup</v-icon>
                      <v-icon v-else>mdi-phone</v-icon>
                    </v-btn>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </template>
          <v-card fab dark left color="indigo" class="w-100 p-10 mt-xs-100" style="margin-top:120px;">
            <v-icon>mdi-email</v-icon>
            <span class="float-right"><a href="#contact" class="color-white" style="text-decoration: underline;">info@drdanielwai.com.sg</a></span>
          </v-card>
          <v-card fab dark color="indigo" class="w-100 p-10">
            <v-icon>mdi-phone</v-icon>
            <span class="float-right">+65 6733 5201</span>
          </v-card>
        </v-speed-dial>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer temporary :right="right" v-model="rightDrawer" fixed app>
      <v-list>
        <v-list-tile class="mt-10 mb-20">
          <a href="https://drdanielwai.com.sg/">
          <img class="logo w-80" :src="logo.img" :style="toolBarStyle.counterTop" :alt="logo.alt">
          </a>
        </v-list-tile>
        <v-list-tile v-for="(link,i) in menutext" :key="i">
          <v-list-tile-content style="border-bottom:1px solid #ccc;">
            <v-btn v-if="link.txt == selectedmenu" flat :style="toolBarStyle.menuTxt" @click="gotopage(link.scrollto,link.goto,link.txt)" class="color-primary" style="text-transform: capitalize;">
              {{ link.txt }}
            </v-btn>
            <v-btn v-else flat :style="toolBarStyle.menuTxt" @click="gotopage(link.scrollto,link.goto,link.txt)" style="text-transform: capitalize;">
              <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>&nbsp;{{ link.txt }}
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <keep-alive>
        <router-view v-bind="language"></router-view>
      </keep-alive>

      <v-container fluid class="bg-2-white">
        <v-layout row wrap >
          <v-flex xs12 md8 offset-md2>
            <Contact />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-footer height="auto">
      <v-container fluid class="footer_Part">
        <v-layout row wrap text-xs-center>
          <v-flex xs12 lg12>
            <v-btn v-for="link in menutext" :key="link.txt" flat :class="link.cls" @click="gotopage(link.scrollto,link.goto,link.txt)">
              <span v-if="link.txt == selectedmenu" style="text-transform: capitalize;" class="color-white font-style-main font-11">{{ link.txt }}</span>
              <span v-else style="text-transform: capitalize;" class="color-primary font-style-main font-11">{{ link.txt }}</span>
            </v-btn>
          </v-flex>
          <v-flex xs12 fluid class="pb-10 pl-0 ml-0 color-white font-75">
            &copy; {{company}} . Powered by <a :href="poweredby.link" v-html="poweredby.name" target="_blank"></a> . Template by <a :href="templateby.link" v-html="templateby.name" target="_blank"></a>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>

    <v-snackbar ref="snackbarApp" v-model="vsnackbar.Show" top auto-height>
      {{ vsnackbar.Msg }}
      <v-btn color="pink" flat @click="vsnackbar.Show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import { mapState } from "vuex";
import Contact from './components/Contact'

export default {
  name: 'App',
  components: {
    Contact
  },
  data () {
    return {
      fab: true,
      fabmob: false,
      language: '',
      selectedmenu: '',
      company: 'Dr. Daniel Wai. All rights reserved',
      poweredby: {
        name: 'AllDigitize.com',
        link: 'https://www.alldigitize.com/',
      },
      templateby: {
        name: 'Colorlib',
        link: 'https://colorlib.com/',
      },
      clipped: true,
      right: false,
      rightDrawer: false,
      toolBarStyle: {
        bgcolor: 'bg-brand10A',
        elevate: 'elevation-0',
        navHeight: 'h-80x',
        menuHeight: 'h-50x',
        menuTxt: '',
        top: '',
        counterTop: ''
      },
      logo: {
        img: require('@/assets/img/logo.png'),
        alt: 'Dr. Daniel Wai',
      },
      menutext: [
        {
          txt: 'Doctor Profile',
          val: '',
          hrf: '',
          goto: '/#profile',
          scrollto: '#profile',
          cls: 'm-0 plr-15'
        },
        {
          txt: 'Our Services',
          val: '',
          hrf: '',
          goto: '/services',
          scrollto: '#toppage',
          cls: 'm-0 plr-15'
        },
        {
          txt: 'Doctor\'s Notes',
          val: '',
          hrf: '',
          goto: '/doctornote',
          scrollto: '#toppage',
          cls: 'm-0 plr-15'
        },
        {
          txt: 'Media/Talks',
          val: '',
          hrf: '',
          goto: '/media',
          scrollto: '#toppage',
          cls: 'm-0 plr-15'
        },
        {
          txt: 'Contact us',
          val: '',
          hrf: '',
          goto: '/#contact',
          scrollto: '#contact',
          cls: 'm-0 plr-15'
        },
      ],
      menuicons: [
        'mdi-blogger',
        'mdi-facebook-box',
        'mdi-home',
      ],
    }
  },
  methods: {
    setlanguage(lang) {
      this.language = lang;
      // this.$router.push('/?lang='+this.language)
      this.$cookies.set('whatlang', lang, "1d")
    },
    gotopage: function (hash,page,selected) {
      this.selectedmenu = selected;
      if (page === '') {
        if (hash === 'mdi-home') {
          this.$router.push('/');
          setTimeout(() => {
            VueScrollTo.scrollTo('#toppage', "", "");
          }, 500);
        } else if (hash === 'fas fa-at') {
          this.$router.push('/')
          setTimeout(() => {
            VueScrollTo.scrollTo('#contact', "", "")
          }, 500);
        } else if (hash === 'mdi-blogger') {
          window.open('https://www.facebook.com/DanielWaiDiabetesThyroidAndHormoneClinicPteLtd/', '_blank')
        } else if (hash === 'mdi-facebook-box') {
          window.open('https://drdanielwai.wordpress.com/', '_blank')
        } else {
          this.$router.push('/')
          setTimeout(() => {
            VueScrollTo.scrollTo(hash, "", "")
          }, 500);
        }
      } else {
        if (hash === '#toppage') {
          VueScrollTo.scrollTo(hash, "", "")
          setTimeout(() => {
            this.$router.push(page)
          }, 500);
        } else if (hash === 'window') {
          window.open(page, '_blank')
        } else {
          this.$router.push(page)
          setTimeout(() => {
            VueScrollTo.scrollTo(hash, "", "")
          }, 500);
        }
      }
    },
  },
  computed: {
    ...mapState({
      vsnackbar: state => state.vsnackbar,
    })
  },
  watch: {
  }
}
</script>

<style>
@import 'assets/css/style.css';
@import 'assets/css/brand.css';
@import 'assets/css/layout.css';
@import 'assets/css/elements.css';
@import 'assets/css/typography.css';
</style>